import React, { useEffect } from 'react';
import Footer from '../components/global-components/Footer';
import Layouts from '../components/global-components/Layouts';
import HeaderV3 from '../components/section-components/Header-v3';
import ProjectDetailsInner from '../components/project-components/Project-details';
import { sectionData } from '../data/section.json';

const ServicesDetails = () => {
    let data = sectionData.sectionTitle;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <Layouts pageTitle='Services'>
                <HeaderV3 title={'Services'} />
                <ProjectDetailsInner />
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <Footer />
            </Layouts>
        </>
    );
}

export default ServicesDetails;
